import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles(() => ({
  settingsHeaderBadge: {
    background: "#ECFDF3 !important",
    color: "#039855",
    borderRadius: 20,
    padding: "8px 12px",
    marginRight: 8,
  },
  settingsHeaderVersion: {
    background: "#F2F4F7 !important",
    color: "#475467",
    borderRadius: 20,
    padding: "8px 12px",
    marginRight: 8,
  },
  headerBreadcrumb: {
    flex: 1,
    "& ol": {
      alignItems: "flex-end",
    },
    "@media (max-width: 600px)": {
      marginBottom: "8px",
    },
  },
  headerBreadcrumbTitle: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: "bold",
    color: "#0055A4",
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
    "&.linkToPeopleTab": {
      cursor: "pointer",
    },
    "@media (max-width: 600px)": {
      fontSize: 14,
      lineHeight: "16px",
    },
  },
  content: {
    // height: "calc(100vh - 206px)",
    // overflowY: "auto",
  },
  isoTooltip: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    width: "100%",
    "& span": {
      color: "#FFF",
      font: "normal 600 14px/24px Manrope",
      marginLeft: "8px",
    },
  },
  swipeArea: {
    height: "0px !important",
  },
}));

export default styles;
